import styled from 'styled-components';
import { colors } from 'constants/colors';
import { styleSizes } from "constants/styleSizes";

export const OptionCardContainer = styled.div<{ selected?: boolean }>`
  display: flex;
  //padding: 5px;
  flex-direction: column;
  cursor: pointer;
  @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
    padding: 0;
  }

  .optionCardTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    flex: 1;

    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      flex-direction: column-reverse;
      gap: 16px;
      margin-bottom: 16px;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 5px;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        align-self: flex-start;
      }
    }

    .titleSelected {
      color: ${colors.optionBackground};
    }

    .description {
      display: flex;
      align-items: center;
      height: 36px;
      font-weight: bold;
      background-color: ${colors.optionBackground};
      padding: 7px 10px;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        align-self: flex-end;
        margin-right: -16px;
      }
      svg {
        position: relative;
        /* width: 21px;
        height: 21px; */
        margin-right: 8px;
      }

      span {
        color: ${colors.white};
        font-size: 14px;
        line-height: 21px;
        height: 21px;
      }
    }
  }

  /* .optionCardAttributes {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    flex-wrap: wrap;
    row-gap: 24px;
    margin-bottom: 20px;
    
    .roomAttribute {
      display: flex;
      flex-direction: row;
      flex-basis: 31%;
      margin: 0 2% 0 0;
      align-items: center;
      font-size: 14px;
      position: relative;
      .roomAttributeIcon{
        width: 38px;
      }
    }
  } */

  .optionCardAttributes {
  display: grid;
  grid-template-columns: 1fr 1fr auto; // 3 columns
  gap: 24px 20px; // row-gap 24px, column-gap 20px
  width: 100%;
  margin-bottom: 20px;
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      grid-template-columns: 1fr 1fr; // 2 columns
      gap: 8px 20px; // row-gap 24px, column-gap 20px
    }
  .roomAttribute {
    display: flex;
    align-items: center;
    font-size: 16px;
    .roomAttributeIcon {
      width: 38px;
      flex-shrink: 0;
    }
  }
}


.optionCardAttributesFeatures {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    flex-wrap: wrap;
    padding: 0 0 24px 0;
    gap: 19px;

    .roomAttributeCross {
      color: ${colors.red};
    }

    .roomAttribute {
      //margin: 0 12px 0 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 16px;
      

      svg {
        position: relative;
        width: 14px;
        height: 14px;
        margin-right: 8px;
        top: 0;
      }
    }
  }

  .windowsOption {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: ${({selected}) => selected? `1px solid ${colors.optionBackground}`: `1px solid ${colors.signInBorderColor}`};
    padding: 11px 0;
    margin: 15px 0 0 0;

    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      }

    .radioAndPrice {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .customizedRadio {
      position: relative;
      width: 21px;
      height: 21px;
      border-radius: 50%;
      border: 2px solid ${colors.signInBorderColor};
      margin: 0 10px;

      ${({selected}) => selected? `
        ::before {
          content: '';
          position: absolute;
          left:3px;
          top: 3px;
          width: 11px;
          height: 11px;
          background-color: ${colors.optionBackground};
          border-radius: 50%;
        }
      `: null};
    }

    .optionDescription {
      font-size: 16px;
      font-weight: 600;
      margin-right: 10px;
    }

    .explanation {
      font-weight: ${({selected}) => selected? `600`: `400`};
      font-size: 14px;
      color: ${colors.secLabel};
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        margin-left: 16px;
      }
    }
  }

  .optionCardPrice {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: ${({selected}) => selected? `1px solid ${colors.optionBackground}`: `1px solid ${colors.signInBorderColor}`};
    
    padding: 11px 0;
    

    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      }

    .radioAndPrice {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .priceDiff {
      font-size: 16px;
      font-weight: 600;
      margin-right: 10px;

    }

    .explanation {
      font-size: 14px;
      color: ${colors.secLabel};
      color: ${colors.almostBlack};
      font-weight: ${({selected}) => selected? `600`: `400`};
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        margin-left: 16px;
      }
    }
  }

  /* @media only screen and (max-width: 1200px) {
    .optionCardTitle {
      flex-direction: column;
      margin-bottom: 10px;

      .title {
        width: 100%;
      }

      .description {
        width: calc( 100% + 40px);
        padding: 7px 20px;
      }
    }

    .optionCardAttributes {
      flex-direction: column;
      row-gap: 10px;
      margin-bottom: 15px;
    }

    .optionCardPrice {
      width: calc( 100% + 40px);
      margin: 0 0 -15px -20px;
      border-left: none;
      border-right: none;
      border-bottom: none;
    }
  } */
`;